import Cookies from "universal-cookie";

const cookies = new Cookies();

export const checkIfNotEmpty = (value) => {
  return (
    value !== null && value !== undefined && value !== "" && value !== "null"
  );
};

export const getUserRole = () => {
  return cookies.get('user_role');
}
